<template>
  <form
    :class="[
      {
        'ps-bg-brand-brown-100': !isHovered,
        'ps-bg-brand-brown-200': isHovered,
        'ps-rounded-lg': !mini
      }
    ]"
    class="ps-dropzone ps-cursor-pointer ps-p-1 ps-overflow-hidden"
    ref="dropzone"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div
      :class="[
        {
          'ps-px-4': !mini,
          'ps-px-1': mini
        }
      ]"
      class=" ps-pointer-events-none ps-w-full ps-h-full ps-flex ps-items-center ps-justify-center ps-border-dashed ps-border-2 ps-border-brand-brown-600 ps-rounded"
    >
      <span class="ps-w-8 ps-h-8 ps-p-1 ps-flex ps-items-center">
        <svg-icon name="upload" width="100%" height="auto" />
      </span>
      <span v-if="!mini" class="ps-pl-2 ps-flex ps-items-center">
        <p class="ps-text-sm ps-text-brand-brown-600">
          Drag and drop or <a href="#">browse</a> your files
        </p>
      </span>
    </div>
  </form>
</template>

<script>
import Dropzone from 'dropzone'
import '@/icons/upload'

export default {
  name: 'BaseDrop',
  props: {
    mini: {
      type: Boolean
    }
  },
  data() {
    return {
      isHovered: false
    }
  },
  mounted() {
    console.log('init dropzone')
    if (!this.dropzone) {
      this.dropzone = new Dropzone(this.$refs.dropzone, { url: '/file/post' })
      console.log(this.dropzone)
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>
